export function extractEmailVerificationTokenFromHash(hash = "") {
    const normalizedHash = String(hash || "").replace(/^#/, "");
    if (!normalizedHash) {
        return null;
    }

    const params = new URLSearchParams(normalizedHash);
    const token = params.get("token");
    return token ? token.trim() : null;
}

export function consumeEmailVerificationTokenFromUrl(browserWindow = window) {
    const token = extractEmailVerificationTokenFromHash(browserWindow.location.hash);
    if (token) {
        const cleanUrl = `${browserWindow.location.pathname}${browserWindow.location.search}`;
        browserWindow.history.replaceState(null, "", cleanUrl);
    }
    return token;
}
